<template>
  <div class="faq-page">
    <div class="container">
      <NavigationBar/>
    </div>

    <div class="container faq-page__header">
      <router-link :to="backLink" class="faq-page__back">&larr; {{ $t('faq-page-back-link') }}</router-link>
    </div>

    <DownloadFaqSection/>
  </div>

  <FooterComponent/>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import NavigationBar from '@/components/NavigationBar.vue';
import FooterComponent from '@/components/Components/FooterComponent.vue';
import DownloadFaqSection from '@/components/Components/Download/DownloadFaqSection.vue';

const { locale } = useI18n();

const backLink = computed(() => (locale.value === 'en' ? '/en/download' : '/download'));
</script>

<style lang="scss" scoped>
.faq-page {
  padding-bottom: 20px;
  display: flow-root;
  background:
    radial-gradient(80% 60% at 80% 0%, #FFE4EA 0%, transparent 60%),
    radial-gradient(70% 60% at 10% 30%, #FBE9EC 0%, transparent 55%),
    linear-gradient(180deg, #FFF5F7 0%, #FEF5F5 60%, #FBE9EC 100%);
}

.faq-page__header {
  margin-top: 20px;
}

.faq-page__back {
  display: inline-block;
  font-family: 'Rubik', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: $color-pink-dark;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

:deep(.download-faq) {
  background: transparent;
  max-width: 960px;
}

@media (max-width: 768px) {
  .faq-page__header {
    margin-top: 12px;
  }
}
</style>
